import { createSlice } from '@reduxjs/toolkit';

import { UserStateType } from '../../types';

const getInitialUserData = (): UserStateType => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const storedUserToken = window.localStorage.getItem('userToken') ?? '';
    const storedUserName = window.localStorage.getItem('userName') ?? '';
    const storedUserEmail = window.localStorage.getItem('userEmail') ?? '';
    return {
      userToken: storedUserToken,
      userName: storedUserName,
      userEmail: storedUserEmail,
    };
  }
  return {
    userToken: '',
    userName: '',
    userEmail: '',
  };
};
const userSlice = createSlice({
  name: 'user',
  initialState: getInitialUserData(),
  reducers: {
    addUser: (state, action) => {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem('userToken', action.payload.$id);
        window.localStorage.setItem('userName', action.payload.name);
        window.localStorage.setItem('userEmail', action.payload.email);
      }
      state.userToken = action.payload.$id;
      state.userName = action.payload.name;
      state.userEmail = action.payload.email;
    },
    removeUser: (state) => {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem('userToken', '');
        window.localStorage.setItem('userName', '');
        window.localStorage.setItem('userEmail', '');
      }
      state.userToken = '';
      state.userName = '';
      state.userEmail = '';
    },
  },
});

export const { addUser, removeUser } = userSlice.actions;
export default userSlice.reducer;
